import App from './App.vue';

export default {
  path: '/CDS_VF_WelfareShelterList',
  name: 'CDS_VF_WelfareShelterList',
  component: App,
  meta: {
    pageProperty: {
      title: '福祉避難所一覧',
      controller: 'CDS_CTR_WelfareShelterList',
    },
  },
};
